<div ngbDropdown [placement]="'bottom-end'" class="btn-group position-relative">
  <button
    type="button"
    class="d-flex align-items-center text-decoration-none bg-transparent border-0 p-0 dropdown-toggle"
    ngbDropdownToggle
    [class.text-warning-emphasis]="isImpersonating()"
  >
    @if (isImpersonating()) {
      <i class="bi bi-person-fill-gear me-2" aria-hidden="true"></i>
      <span>{{ impersonatedUser()?.email }}</span>
    } @else {
      <span>{{ userName() }}</span>
    }
  </button>

  <div
    ngbDropdownMenu
    class="dropdown-menu dropdown-menu-sm-start"
    style="top: 100%; min-width: 100%"
  >
    @if (isImpersonating()) {
      <button
        ngbDropdownItem
        class="dropdown-item d-flex gap-2 align-items-center text-warning-emphasis"
        type="button"
        (click)="stopImpersonating()"
      >
        <i class="bi bi-x-circle"></i>
        <span i18n="dropdown option|Menu option to stop impersonating@@stopImpersonatingButton">
          Stop impersonating
        </span>
      </button>
    } @else {
      <button
        ngbDropdownItem
        class="dropdown-item d-flex gap-2 align-items-center"
        type="button"
        (click)="logout()"
      >
        <i class="bi bi-box-arrow-right"></i>
        <span
          i18n="
            dropdown option|Menu option to log out of the application from the user
            dropdown@@logoutButton"
        >
          Logout
        </span>
      </button>
    }
  </div>
</div>
